import { Component, OnInit } from "@angular/core";
import { OrderService } from "../service/order.service";
import { OrderDetails } from "../model/orderDetails";
import { NgForm } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-update-order",
  templateUrl: "./update-order.component.html",
  styleUrls: ["./update-order.component.css"],
})
export class UpdateOrderComponent implements OnInit {
  orderNumber = "";

  orderDetails: OrderDetails[];

  selectedOrder: OrderDetails | null = null;

  constructor(
    private orderService: OrderService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      if (params["orderNumber"]) {
        this.orderNumber = params["orderNumber"];
        this.getData(); // חיפוש אוטומטי
      }
    });
  }

  getData = () => {
    console.log(this.orderNumber);

    this.orderService.getOrderDetailsByOrderNumber(this.orderNumber).subscribe(
      (response: OrderDetails[]) => {
        // Expecting an array of OrderDetails
        console.log(response);
        if (response && response.length > 0) {
          this.orderDetails = response;
        } else {
          this.orderDetails = [];
        }
      },
      (error) => {
        console.log(error);
      },
    );
  };

  updateOrder = (orderForm: NgForm) => {
    if (!this.selectedOrder) return;

    let updatedOrder: OrderDetails = {
      ...this.selectedOrder, // Copy existing order data
      ...orderForm.value, // Overwrite with form data
      OrderNumber: this.orderNumber,
    };

    console.log(updatedOrder);

    this.orderService.updateOrder(updatedOrder).subscribe(
      (response) => {
        if (response == "good") {
          alert("העידכון בוצע בהצלחה!");
          this.selectedOrder = null; // Hide form after update
          this.getData();
        } else {
          alert("משהו השתבש בדרך...");
        }
        console.log(response);
      },
      (error) => {
        console.log(error);
      },
    );
  };

  selectOrderForEdit(order: OrderDetails) {
    this.selectedOrder = { ...order }; // Clone the selected order to avoid modifying the table directly
  }
}



// WEBPACK FOOTER //
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/update-order/update-order.component.ts